// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/agents/tools" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentsTools } from "./constants";
import type { GenerativeAiAgentsToolsResult, GenerativeAiAgentsToolsParams } from "./types";
import { isGenerativeAiAgentsToolsResult } from "./validators";

export const getGenerativeAiAgentsTools = reactQueryFetcherAdapter(
  generativeAiAgentsTools,
  (signal: AbortSignal, params?: GenerativeAiAgentsToolsParams): Promise<GenerativeAiAgentsToolsResult> => {
    const queryParams: Record<string, string> = {};
    if (params?.interaction_site !== undefined) {
      queryParams.interaction_site = String(params.interaction_site);
    }
    return fetch("/generative_ai/agents/tools", "GET", queryParams, { signal });
  },
  isGenerativeAiAgentsToolsResult
);
